import React, { useRef } from "react";

import styled from "styled-components";

import useToast from "components/atoms/toast/useToast";

import ReferenceBibInfoForm from "components/organisms/reference/ReferenceBibInfoForm";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

const Container = styled.div`
    width: 100%;
`;

function ReferenceBibInfoEditModal(props) {
    const { setToast } = useToast();

    const formRef = useRef();
    const handleSaveButton = () => {
        formRef.current.bibJsonMutate(formRef.current.getCurrentBibJson(), {
            onSuccess: () => {
                setToast("수정되었습니다.", "info");
                props.exitModal();
            },
        });
    };

    return (
        <Container>
            <ReferenceBibInfoForm ref={formRef} bibliography={props.reference} />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"저장"}
                leftOnClick={props.exitModal}
                rightOnClick={handleSaveButton}
            />
        </Container>
    );
}

export default ReferenceBibInfoEditModal;
